import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { If, Unless } from 'src/Components'
import { selectEditableLoanBalance } from 'src/store/selectors/home/loans'
import EditBalanceInterstital from './EditBalanceInterstitial'
import EditBalanceForm from './EditBalanceForm'

const EditBalance = () => {
  const value = useSelector(selectEditableLoanBalance)
  const [shouldShowInterstitial, setShouldShowInterstitial] = useState(!value)
  const hideInterstitial = () => setShouldShowInterstitial(false)

  return (
    <>
      <If condition={shouldShowInterstitial}>
        <EditBalanceInterstital hideInterstitial={hideInterstitial} />
      </If>
      <Unless condition={shouldShowInterstitial}>
        <EditBalanceForm />
      </Unless>
    </>
  )
}

export default EditBalance
